import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  data: [],
  createError: "",
  createStatus: "idle",
  fetchError: "",
  fetchStatus: "idle",
  deleteError: "",
  deleteStatus: "idle",
  examData: null,
  getExamError: "",
  getExamStatus: "idle",
};

export const fetchExams = createAsyncThunk(
  "exams/fetchExams",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get("/exam");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getAExam = createAsyncThunk(
  "exams/getAExam",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get(`/exam/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createExam = createAsyncThunk(
  "exams/createExam",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/exam/create", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const deleteExam = createAsyncThunk(
  "exams/deleteExam",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.delete(`/exam/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.reponse.data : error);
    }
  }
);

const examsSlice = createSlice({
  name: "exams",
  initialState,
  reducers: {
    setCreateExamIdleStatus: (state) => {
      state.createError = "";
      state.createStatus = "idle";
    },
    clearExamData: (state) => {
      state.examData = null;
      state.getExamError = "";
      state.getExamStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Exams
      .addCase(fetchExams.pending, (state, action) => {
        state.fetchStatus = "loading";
        state.fetchError = "";
      })
      .addCase(fetchExams.fulfilled, (state, action) => {
        state.fetchStatus = "success";
        state.fetchError = "";
        state.data = action.payload.data;
      })
      .addCase(fetchExams.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.fetchError = action.payload.message;
      })
      // Get a exam
      .addCase(getAExam.pending, (state, action) => {
        state.getExamStatus = "loading";
        state.getExamError = "";
      })
      .addCase(getAExam.fulfilled, (state, action) => {
        state.getExamStatus = "success";
        state.getExamError = "";
        state.examData = action.payload.data;
      })
      .addCase(getAExam.rejected, (state, action) => {
        state.getExamStatus = "failed";
        state.getExamError = action.payload.message;
      })
      // Create exam
      .addCase(createExam.pending, (state, action) => {
        state.createStatus = "loading";
        state.createError = "";
      })
      .addCase(createExam.fulfilled, (state, action) => {
        state.createStatus = "success";
        state.createError = "";
        state.data = [...state.data, action.payload.data];
        // state.data = action.payload.data;
      })
      .addCase(createExam.rejected, (state, action) => {
        state.createStatus = "failed";
        state.createError = action.payload.message;
      })
      //   Delete exam
      .addCase(deleteExam.pending, (state, action) => {
        state.deleteStatus = "loading";
        state.deleteError = "";
      })
      .addCase(deleteExam.fulfilled, (state, action) => {
        state.deleteStatus = "success";
        state.deleteError = "";
        state.data = state.data.filter(
          (exam) => exam._id !== action.payload.data
        );
      })
      .addCase(deleteExam.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.deleteError = action.payload.message;
      });
  },
});

export const { setCreateExamIdleStatus, clearExamData } = examsSlice.actions;

export const getExams = (state) => state.exams.data;
export const getExamsStatus = (state) => state.exams.fetchStatus;
export const getExamsError = (state) => state.exams.fetchError;

export const getCreateExamsStatus = (state) => state.exams.createStatus;
export const getCreateExamsError = (state) => state.exams.createError;

export const getDeleteExamsStatus = (state) => state.exams.deleteStatus;
export const getDeleteExamsError = (state) => state.exams.deleteError;

export const getExamData = (state) => state.exams.examData;
export const getGetExamStatus = (state) => state.exams.getExamStatus;
export const getGetExamError = (state) => state.exams.getExamError;

export default examsSlice.reducer;
